const SET_USER = (state, payload) => {
    state.user = '';
    state.user = payload;
}
const CLEAR_USER = (state) => {
    state.user = '';
}

const SET_AUTHORIZED_USER = (state, payload) => {
    state.authorized_user = {};
    state.authorized_user = payload;
}
const CLEAR_AUTHORIZED_USER = (state) => {
    state.authorized_user = {};
}

const SET_SESSION = (state, payload) => {
    state.session = '';
    state.session = payload;
}
const CLEAR_SESSION = (state) => {
    state.session = '';
}

const SET_SESSION_DETAILS = (state, payload) => {
    state.session_details = '';
    state.session_details = payload;
}
const CLEAR_SESSION_DETAILS = (state) => {
    state.session_details = '';
}

const SET_PATH_INTENTION = (state, payload) => {
    state.path_intention = '';
    state.path_intention = payload;
}
const CLEAR_PATH_INTENTION = (state) => {
    state.path_intention = '';
}

const SET_CANCEL_PURCHASE = (state, payload) => {
    state.cancel_purchase = '';
    state.cancel_purchase = payload;
}
const CLEAR_CANCEL_PURCHASE = (state) => {
    state.cancel_purchase = '';
}

const CLEAR_STATES = (state) => {
    state.session_details = '';
    state.session = '';
    state.user = '';
    state.meta = [];
    // Path intention state variable is excluded here as it is needed even if session is expired
    // Authorized user state variable is excluded here as it is needed even if the main session states are wiped out
}

export {
    SET_USER,
    CLEAR_USER,
    SET_AUTHORIZED_USER,
    CLEAR_AUTHORIZED_USER,
    SET_SESSION,
    SET_SESSION_DETAILS,
    CLEAR_SESSION_DETAILS,
    CLEAR_SESSION,
    SET_PATH_INTENTION,
    CLEAR_PATH_INTENTION,
    SET_CANCEL_PURCHASE,
    CLEAR_CANCEL_PURCHASE,
    CLEAR_STATES
}
